/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * EmailTemplateDtoBase
 * auto generated base class for the model EmailTemplateDtoModel.
 */
export const EmailTemplateDtoModelBase = ModelBase
  .named('EmailTemplateDto')
  .props({
    __typename: types.optional(types.literal("EmailTemplateDto"), "EmailTemplateDto"),
    subject: types.union(types.undefined, types.string),
    body: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class EmailTemplateDtoModelSelector extends QueryBuilder {
  get subject() { return this.__attr(`subject`) }
  get body() { return this.__attr(`body`) }
}
export function selectFromEmailTemplateDto() {
  return new EmailTemplateDtoModelSelector()
}

export const emailTemplateDtoModelPrimitives = selectFromEmailTemplateDto().subject.body
